export default __webpack_public_path__ + "images/00b1f5a92bf76107bca4236efe111ab4-2_4K_1920x544.jpg";